export const getClientSOCartSelector = (state) => state.personalizeOfferReducer.getClientSOCartReducer;
